import Assessment, { IAssessmentSnapshotIn } from "./Assessment";

export const FamilyAssessmentQuestionsSnapshot = [
  {
    key: "FamilyDomainTask1",
    timeToComplete: null,
    question:
      "Have you convened a family meeting to develop an initial plan about how each person can be involved in caring for the older adult?",
    answer: "",
    resource: "blank",
    taskName: "Family Meeting",
  },
  {
    key: "FamilyDomainTask2",
    timeToComplete: null,
    question:
      "Have you discussed with the older adult how a pet or animal companion can contribute to their well-being?",
    answer: "",
    resource: "blank",
    taskName: "Companion Animals",
  },
  {
    key: "FamilyDomainTask3",
    timeToComplete: null,
    question:
      "Have you worked with the older adult and other family members to develop specific strategies for responding to crisis situations and catastrophic events?",
    answer: "",
    resource: "blank",
    taskName: "Crisis Planning",
  },
  {
    key: "FamilyDomainTask4",
    timeToComplete: null,
    question:
      "Have you had a safety assessment completed of the older adult's living space and made the recommended changes?",
    answer: "",
    resource: "blank",
    taskName: "Home Safety",
  },
  {
    key: "FamilyDomainTask5",
    timeToComplete: null,
    question:
      "Have you worked with your older adult to help them identify and use electronic devices, apps, and websites to improve their quality of life?",
    answer: "",
    resource: "blank",
    taskName: "Using Technology",
  },
  {
    key: "FamilyDomainTask6",
    timeToComplete: null,
    question:
      "Have you identified evaluation criteria for employing all professional caregivers, home care workers, and other employed caregivers who might work with your older adult?",
    answer: "",
    resource: "blank",
    taskName: "Paid Caregivers",
  },
  {
    key: "FamilyDomainTask7",
    timeToComplete: null,
    question:
      "Have you learned about how to support the older adult's role as a grandparent?",
    answer: "",
    resource: "blank",
    taskName: "Grandparent Relationships",
  },
  {
    key: "FamilyDomainTask8",
    timeToComplete: null,
    question:
      "Have you developed a plan and identified resources to care for yourself as a caregiver?",
    answer: "",
    resource: "blank",
    taskName: "Caring for Yourself",
  },
  {
    key: "FamilyDomainTask9",
    timeToComplete: null,
    question:
      "Have you developed a plan to maintain your older adult’s home (e.g., home repairs, landscaping, replacement of major items) if they cannot do so without help?",
    answer: "",
    resource: "blank",
    taskName: "Home Maintenance",
  },
  {
    key: "FamilyDomainTask10",
    timeToComplete: null,
    question:
      "Are you prepared to support your older adult in widowhood?",
    answer: "",
    resource: "blank",
    taskName: "Widowhood Support",
  },
];

export const FamilyAssessmentSnapshot: IAssessmentSnapshotIn = {
  id: "Family",
  questions: FamilyAssessmentQuestionsSnapshot,
  infoSlideKeys: [
    "FamilyDomainTask1",
    "FamilyDomainTask2",
    "FamilyDomainTask3",
    "FamilyDomainTask4",
    "FamilyDomainTask5",
    "FamilyDomainTask6",
    "FamilyDomainTask7",
    "FamilyDomainTask8",
    "FamilyDomainTask9",
    "FamilyDomainTask10",
  ],
};

export const DefaultLegalAssessment = Assessment.create(
  FamilyAssessmentSnapshot
);
